import { render, staticRenderFns } from "./newaccount.vue?vue&type=template&id=2f6ba86e&"
import script from "./newaccount.vue?vue&type=script&lang=js&"
export * from "./newaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports